export type IconName =
  | 'map'
  | 'lease'
  | 'payment'
  | 'search'
  | 'alert'
  | 'receipt'
  | 'track'
  | 'records'
  | 'building'
  | 'gis'
  | 'dashboard'
  | 'field'
  | 'ai'
  | 'apply'
  | 'pay'
  | 'trackStep';

export const ICON_PATHS: Record<IconName, string> = {
  map: 'M3 6l6-3 6 3 6-3v15l-6 3-6-3-6 3V6z M9 3v15 M15 6v15',
  lease: 'M4 19V5a2 2 0 012-2h12a2 2 0 012 2v14M8 7h8M8 11h8M8 15h5',
  payment: 'M3 10h18M7 15h1m4 0h1m4 0h1M6 6h12a2 2 0 012 2v10a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2z',
  search: 'M11 19a8 8 0 100-16 8 8 0 000 16zM21 21l-4.35-4.35',
  alert: 'M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z',
  receipt: 'M6 2h12v20l-3-2-3 2-3-2-3 2V2z M9 7h6M9 11h6',
  track: 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z',
  records: 'M7 3h10a2 2 0 012 2v14l-4-2-4 2-4-2-4 2V5a2 2 0 012-2z M9 7h6M9 11h6',
  building: 'M4 21V9l8-4 8 4v12M9 21v-6h6v6',
  gis: 'M12 2C8 6 4 8 4 12s4 6 8 10 8-6 8-10-4-6-8-10z M12 12a2 2 0 100-4 2 2 0 000 4z',
  dashboard: 'M4 19V5M4 19h16M8 19V9m4 10V7m4 12v-4',
  field: 'M12 18h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z',
  ai: 'M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1M9 12a3 3 0 106 0',
  apply: 'M11 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2v-5M18.5 2.5a2.12 2.12 0 013 3L12 15l-4 1 1-4 9.5-9.5z',
  pay: 'M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2z',
  trackStep: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4',
};

export const SERVICE_ICONS: Record<string, IconName> = {
  mapApproval: 'map',
  leaseRenewal: 'lease',
  payChallan: 'payment',
  propertySearch: 'search',
  encroachment: 'alert',
  receipt: 'receipt',
  trackStatus: 'track',
};

export const MODULE_ICONS: Record<string, IconName> = {
  records: 'records',
  lease: 'lease',
  revenue: 'payment',
  gis: 'gis',
  building: 'building',
  dashboards: 'dashboard',
  field: 'field',
  ai: 'ai',
};

export const STEP_ICONS: Record<string, IconName> = {
  apply: 'apply',
  pay: 'pay',
  track: 'trackStep',
  receipt: 'receipt',
};
